import './how.css'
import { useI18n } from '../lib/i18n'
import { SectionHeader } from '../components/SectionHeader'
import { HudCard } from '../components/HudCard'
import { Reveal } from '../components/Reveal'
import { StageRail } from '../components/StageRail'
import { MonoTag } from '../components/MonoTag'

// Section 03 — QUY TRÌNH: 8-stage rail + 3 expansion cards (key steps).
export default function HowItWorks() {
  const { lang } = useI18n()
  const C = (
    {
      vi: {
        kicker: 'QUY TRÌNH',
        title: (
          <>
            Từ một thửa đất đến <em>hồ sơ nộp EU</em>.
          </>
        ),
        sub: 'Tám bước khép kín — vẽ thửa, đối chiếu vệ tinh, ra phán quyết và xuất hồ sơ sẵn sàng nộp.',
        stages: [
          { n: '01', label: 'Tiếp nhận' },
          { n: '02', label: 'Bản đồ thửa' },
          { n: '03', label: 'Pháp lý đất' },
          { n: '04', label: 'Sàng lọc vệ tinh' },
          { n: '05', label: 'Rà soát' },
          { n: '06', label: 'Lập hồ sơ' },
          { n: '07', label: 'Bàn giao' },
          { n: '08', label: 'Giám sát' },
        ],
        cards: [
          {
            tag: 'STEP 02',
            title: 'Vẽ & định vị thửa',
            body: 'Vẽ ranh giới hoặc thả điểm GPS để khoá toạ độ và diện tích từng thửa. Mỗi thửa thành một đối tượng có thể truy vết.',
          },
          {
            tag: 'STEP 04 · 05',
            title: 'Sàng lọc vệ tinh + phán quyết',
            body: 'Đối chiếu ranh thửa với Sentinel-2, JRC TMF, GFC loss, GFW và Whisp so mốc 31/12/2020. Model trả về: Đạt · Cần rà soát · Không đạt.',
          },
          {
            tag: 'STEP 06 · 07',
            title: 'Xuất Lot Passport + GeoJSON',
            body: 'Đóng gói Lot Passport kèm GeoJSON cho TRACES NT. Nhà nhập khẩu EU dùng bộ hồ sơ này để nộp DDS đúng quy định.',
          },
        ],
      },
      en: {
        kicker: 'WORKFLOW',
        title: (
          <>
            From a single plot to an <em>EU-ready dossier</em>.
          </>
        ),
        sub: 'Eight closed-loop steps — map the plot, check it against satellites, reach a verdict, export a submission-ready file.',
        stages: [
          { n: '01', label: 'Intake' },
          { n: '02', label: 'Plot map' },
          { n: '03', label: 'Land legality' },
          { n: '04', label: 'Satellite screen' },
          { n: '05', label: 'Review' },
          { n: '06', label: 'Dossier' },
          { n: '07', label: 'Handover' },
          { n: '08', label: 'Monitoring' },
        ],
        cards: [
          {
            tag: 'STEP 02',
            title: 'Draw & locate the plot',
            body: 'Trace a boundary or drop GPS points to lock each plot’s coordinates and area. Every plot becomes a traceable object.',
          },
          {
            tag: 'STEP 04 · 05',
            title: 'Satellite screen + verdict',
            body: 'Match plot boundaries against Sentinel-2, JRC TMF, GFC loss, GFW and Whisp versus the 31 Dec 2020 cutoff. The model returns: Pass · Needs review · Fail.',
          },
          {
            tag: 'STEP 06 · 07',
            title: 'Export Lot Passport + GeoJSON',
            body: 'Bundle a Lot Passport with GeoJSON for TRACES NT. The EU importer uses this package to file the DDS in line with the rules.',
          },
        ],
      },
    } as const
  )[lang]

  return (
    <section id="how" className="section how">
      <div className="container">
        <SectionHeader index="04" kicker={C.kicker} title={C.title} sub={C.sub} />

        <Reveal delay={0.06} className="how-rail-wrap">
          <StageRail stages={[...C.stages]} active={3} />
        </Reveal>

        <div className="how-grid">
          {C.cards.map((card, i) => (
            <Reveal key={card.tag} delay={0.1 + i * 0.08}>
              <HudCard className="how-card" header={<MonoTag>{card.tag}</MonoTag>} brackets>
                <h3 className="how-card-title">{card.title}</h3>
                <p className="how-card-body">{card.body}</p>
              </HudCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
